import { IProject, IProjectOwner } from '../types/project.interface';

const FAKE_FIRST_NAMES = ['James', 'Sarah', 'Michael', 'Emma', 'David', 'Olivia'];
const FAKE_LAST_NAMES = ['Smith', 'Johnson', 'Williams', 'Brown', 'Taylor', 'Wilson'];

function hashSeed(seed: string): number {
  let hash = 0;
  for (let i = 0; i < seed.length; i++) {
    hash = (hash << 5) - hash + seed.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash);
}

function pickFrom<T>(items: T[], seed: string): T {
  return items[hashSeed(seed) % items.length];
}

export function projectDisplaySeed(project: IProject): string {
  return project._id ?? String(project.code ?? 'project');
}

export function projectHasRealOwnerName(owner: IProjectOwner | null | undefined): boolean {
  const first = owner?.first_name?.trim();
  const last = owner?.last_name?.trim();
  return !!(first || last);
}

export function projectRealFirstName(owner: IProjectOwner | null | undefined): string {
  return owner?.first_name?.trim() ?? '';
}

export function projectRealLastName(owner: IProjectOwner | null | undefined): string {
  return owner?.last_name?.trim() ?? '';
}

export function projectDisplayFirstName(
  project: IProject,
  hasRealOwner: boolean
): string {
  if (hasRealOwner) {
    return projectRealFirstName(project.owner);
  }
  return pickFrom(FAKE_FIRST_NAMES, `${projectDisplaySeed(project)}-first`);
}

export function projectDisplayLastName(
  project: IProject,
  hasRealOwner: boolean
): string {
  if (hasRealOwner) {
    return projectRealLastName(project.owner);
  }
  return pickFrom(FAKE_LAST_NAMES, `${projectDisplaySeed(project)}-last`);
}

export function shouldBlurProjectOwnerField(
  hasRealOwner: boolean
): boolean {
  return !hasRealOwner;
}
